import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { Tenant } from "../models/tenant/tenant"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"
import { CurrentTenant } from "@app/core/models/CurrentTenant"
import { Observable, shareReplay, take } from "rxjs"

@Injectable()
export class TenantService {
  private post_tenant_url: string
  private get_tenant_id_url: string
  private get_tenant_url: string
  private put_tenant_id_url
  private get_tenantOptions_url: string
  private get_current_tenant: string
  private get_license_order_number_existing: string
  cachedTenant$: Observable<CurrentTenant>

  private buildUrls(tenantUrl: string) {
    this.post_tenant_url =
      tenantUrl + environment.endpointSchool.routes.post_teanant
    this.get_tenant_id_url =
      tenantUrl + environment.endpointSchool.routes.get_tenant_id
    this.get_tenant_url =
      tenantUrl + environment.endpointSchool.routes.get_tenant
    this.put_tenant_id_url =
      tenantUrl + environment.endpointSchool.routes.put_tenant_id
    this.get_tenantOptions_url =
      tenantUrl + environment.endpointSchool.routes.get_tenant_options
    this.get_current_tenant =
      tenantUrl + environment.endpointSchool.routes.get_current_tenant
    this.get_license_order_number_existing =
      tenantUrl +
      environment.endpointSchool.routes.get_license_order_number_existing
  }

  constructor(private httpClient: HttpClient) {
    this.buildUrls(environment.endpointSchool.url)
  }

  postTenant(tenant: Tenant) {
    return this.httpClient.post(this.post_tenant_url, tenant)
  }

  getOne(id: string) {
    return this.httpClient.get<any>(
      this.get_tenant_id_url.replace("{tenantId}", id)
    )
  }

  getCurrentTenant() {
    if (!this.cachedTenant$) {
      this.setTenant()
    }
    return this.cachedTenant$
  }

  setTenant() {
    this.cachedTenant$ = this.httpClient
      .get<CurrentTenant>(this.get_current_tenant)
      .pipe(take(1), shareReplay(1))
    return this.cachedTenant$
  }

  getAllTenantsOptions() {
    return this.httpClient.get<any>(this.get_tenantOptions_url)
  }

  getTenants(model: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (!isNullOrUndefined(model.Name)) {
      params = params.set("Name", String(model.Name))
    }
    if (!isNullOrUndefined(model.AskPage)) {
      params = params.set("Page", String(model.AskPage))
    }
    if (!isNullOrUndefined(model.ItensPerPage)) {
      params = params.set("PageSize", String(model.ItensPerPage))
    }
    if (!isNullOrUndefined(model.OrderByProperty)) {
      params = params.set("OrderByProperty", String(model.OrderByProperty))
    }
    if (!isNullOrUndefined(model.OrderByDirection)) {
      params = params.set("OrderByDirection", String(model.OrderByDirection))
    }

    return this.httpClient.get<any>(this.get_tenant_url, { params })
  }

  putTenant(tenant: Tenant) {
    return this.httpClient.put(
      this.put_tenant_id_url.replace("{tenantId}", tenant.id),
      tenant
    )
  }

  orderNumberExistInOtherTenant(tenantId: string, licenseOrderNumber: string) {
    return this.httpClient.get(
      this.get_license_order_number_existing
        .replace("{tenantId}", tenantId)
        .replace("{number}", licenseOrderNumber)
    )
  }
}

